// extracted by mini-css-extract-plugin
module.exports = {"spacerMobile":"Spacer_spacerMobile__16ktu","spacerTablet":"Spacer_spacerTablet__sf9pq","spacerDesktop":"Spacer_spacerDesktop__j2jku"};